import moment from "moment";
import React from "react";
import "../style.css"; 

const TextCell = ({ value }) => (
  <div className="table-text-cell" title={value}>
    {value}
  </div>
);

const AddressCell = ({ address }) => (
  <div className="table-address-cell" title={address}>
    {address}
  </div>
);

export const LOCAL_PARTY_MASTER_COLUMNS = [
  {
    Header: "Bank Name",
    id: "bankName",
    accessor: d => <TextCell value={d.bankName} />
  },
  {
    Header: "IFSC",
    id: "ifsc",
    accessor: d => <TextCell value={d.ifsc} />
  },
  {
    Header: "Local Party Entity Name",
    id: "localPartyEntityName",
    accessor: d => <TextCell value={d.localPartyEntityName} />,
    minWidth: 200,
    maxWidth: 400
  },
  {
    Header: "Local Party - GST",
    id: "localPartyGstNumber",
    accessor: d => <TextCell value={d.localPartyGstNumber} />
  },
  {
    Header: "Local Party - PAN",
    id: "localPartyPan",
    accessor: d => <TextCell value={d.localPartyPan} />
  },
  {
    Header: "Address",
    id: "localPartyAddress",
    accessor: d => <AddressCell address={d.localPartyAddress} />,
    minWidth: 200,
    maxWidth: 450
  },
  {
    Header: "State",
    id: "localPartyState",
    accessor: d => <TextCell value={d.localPartyState} />
  },
  {
    Header: "Pincode",
    id: "localPartyPinCode",
    accessor: d => <TextCell value={d.localPartyPinCode} />
  },
  {
    Header: "Created By",
    id: "createdBy",
    accessor: d => <TextCell value={d.createdBy} />
  },
  {
    Header: "Created At",
    id: "createdAt",
    accessor: d => (
      <TextCell value={moment(d.createdAt).format("DD-MM-YYYY")} />
    )
  }
];

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 0;
